interface EnvironmentConfig {
  apiUrl: string;
  appType: 'client' | 'partner';
  basePath: string;
}

const getEnvironmentConfig = (): EnvironmentConfig => {
  const hostname = window.location.hostname;
  const port = window.location.port;

  // Localhost development
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === 'cp-dev-cabinet.onlyu.market') {
    return {
      apiUrl: process.env.REACT_APP_API_DEV_URL || 'https://api-dev.onlyu.market/',
      appType: 'client', // Default to client for localhost
      basePath: '',
    };
  }
  // Default fallback
  return {
    apiUrl: process.env.REACT_APP_API_DEV_URL || 'https://api.onlyu.market/',
    appType: 'client',
    basePath: '',
  };
};

export const environmentConfig = getEnvironmentConfig();

export const isClientApp = environmentConfig.appType === 'client';
export const isPartnerApp = environmentConfig.appType === 'partner';
export const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'; 